import { formScroll } from './form';

/*
* Position et total réels dans un parcours conditionnel.
*
* Le numéro d'étape ne veut rien dire pour la personne qui remplit le
* formulaire: un choix peut l'envoyer de l'étape 2 à l'étape 21, et le compteur
* saute alors à 21 sur 21 alors qu'il reste une question. On compte donc les
* étapes réellement franchies, gardées dans steps.history, et on estime celles
* qui restent en suivant les data-goto du DOM depuis l'étape courante: le choix
* déjà coché s'il existe, sinon le chemin par défaut de l'étape.
*
* Le total inclut l'envoi, pour que la barre n'atteigne 100 % qu'une fois le
* formulaire parti. Il bouge quand une réponse change de branche, ce qui est
* voulu: le parcours a vraiment raccourci ou rallongé.
*/
function stepProgress(steps) {
  var position = steps.is_conditional ? steps.history.length : steps.current_index;
  var remaining = 0;
  var index = steps.current_index;
  var seen = [];

  while (index && seen.indexOf(index) === -1) {
    seen.push(index);

    var $step = steps.get_step(index);
    if (!$step || !$step.length) break;

    var target = 'default';
    if (steps.is_conditional) {
      var $radio = $step.find('input[type="radio"][data-goto]:checked').first();
      var $option = $step.find('select option:selected[data-goto]').first();
      if ($radio.length) {
        target = $radio.attr('data-goto');
      } else if ($option.length) {
        target = $option.attr('data-goto');
      }
      if (target === 'default') {
        target = $step.attr('data-goto') || 'default';
      }
    }
    if (target === 'submit') break;

    var next = isNaN(Number(target)) ? index + 1 : Number(target);
    if (next <= 0 || next > steps.max_steps) break;

    remaining++;
    index = next;
  }

  return {
    position: position,
    total: position + remaining + 1,
  };
}

export function Demande_FormOptions() {
  return {
    steps: {
      use_steps: true,
      submit_steps: true,
      initial_step: 1,
    },
    auto_scroll: false,
    onStep: function(steps) {
      var progress = stepProgress(steps);
      steps.form.find('.form__line').css('--progress', (progress.position / progress.total * 100) + '%');
      steps.form.find('.form__pagination span').text(progress.total);
      steps.get_current_step().find('.current-step-num').html(progress.position + '<span> / ' + progress.total + '</span>');
    },
    // onBeforeInit: function(self) {
    //   console.log('onBeforeInit', self)
    // },
    // onInit: function(self) {
    //   console.log('onInit', self)
    // },
    // onBeforeSubmit: function(self) {
    //   console.log('onBeforeSubmit', self)
    // },
    // onSubmit: function(self) {
    //   console.log('onSubmit', self)
    // },
    // onSuccess: function(response, self) {
    //   console.log('onSuccess', response, self)
    // },
    onStepSuccess: function(response, self) {
      //console.log('onStepSuccess', response, self);

      formScroll();

      const $step = self.find('.form-step[aria-expanded="true"]');
      const $error = $step.find('.form-error');

      if ($error.length) {
        $step.prepend($error);
      }

      $step.removeClass('--locked');

      const $nextStep = $step.next('.form-step');
      if ($nextStep.length) {
        $nextStep.removeClass('--locked');
      }
    },
    // onError: function(response, self) {
    //   console.log('onError', response, self)
    // },
    // onFeedback: function(response, self) {
    //   console.log('onFeedback', response, self)
    // },
  }
}
